import { makeStyles } from '@material-ui/styles';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import DefaultMap from '../components/map/DefaultMap';
import FeatureDetailsDialog from '../components/map/FeatureDetailsDialog';
import DownloadMasterPlanControl from '../components/map/controls/DownloadMasterPlanControl';
import ExportPdfControl from '../components/map/controls/ExportPdfControl';
import MeasureControl from '../components/map/controls/MeasureControl';
import MultiDrawControl from '../components/map/controls/MultiDrawControl';
import PhotoWMSControl from '../components/map/controls/PhotoWMSControl';
import { Authority } from '../constants/authConstants';
import AuthUtils from '../utils/AuthUtils';
import RouteUtils from '../utils/RouteUtils';

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.up('sm')]: {
      height: "calc(100vh - 102px)"
    },
    [theme.breakpoints.down('sm')]: {
      height: "calc(100vh - 56px)"
    },
  },
}));

export default function MainMap() {
  const classes = useStyles();
  const mobileView = useSelector(state => state.global.mobileView);
  const { authUser } = useSelector(state => state.auth);

  useEffect(() => {
    RouteUtils.setDocumentTitle('map');
  }, []);

  const controls = [<ExportPdfControl />];
  const isGov = AuthUtils.isGov(authUser);
  if(isGov || AuthUtils.isPartner(authUser)){
    controls.push(<MultiDrawControl />);
  }
  if (!mobileView) {
    controls.push(<MeasureControl />);
    if(AuthUtils.hasAnyAuthority(authUser, [Authority.UC39_master_plan_export, Authority.UC39_partner_master_plan_export])){
      controls.push(<DownloadMasterPlanControl />);
    }
  }
  if(isGov) {
    controls.push(<PhotoWMSControl/>);
  }

  return (
    <div className={classes.container}>
      <DefaultMap extraControls={controls} />

      <Routes>
        <Route path="/f/*" element={<FeatureDetailsDialog/>} />
      </Routes>
    </div>
  );
}